// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__2ezYC","card":"styles_card__2vR15","deleteBtn":"styles_deleteBtn__3uu3_"};